import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

export default function ProfileSubmissions({ user }) {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSubmissions() {
      setLoading(true);
      let subData = [];
      // Try by user_id if available in request table
      const { data: reqById } = await supabase
        .from('request')
        .select('id, title, status, journal, submitted_at, pdf_url')
        .eq('user_id', user.id);
      if (reqById && reqById.length > 0) {
        subData = reqById;
      }
      if (subData.length === 0) {
        // Fallback: filter by username/email if present
        const { data: userData } = await supabase
          .from('users')
          .select('username, email')
          .eq('id', user.id)
          .single();
        let orFilters = [];
        if (userData.username) orFilters.push(`username.eq.${userData.username}`);
        if (userData.email) orFilters.push(`email.eq.${userData.email}`);
        if (orFilters.length > 0) {
          const { data: reqByUser } = await supabase
            .from('request')
            .select('id, title, status, journal, submitted_at, pdf_url')
            .or(orFilters.join(','));
          if (reqByUser) subData = reqByUser;
        }
      }
      setSubmissions(subData || []);
      setLoading(false);
    }
    if (user) fetchSubmissions();
  }, [user]);

  if (!user) return <div className="container mt-5"><div className="alert alert-warning">You must be logged in to view your submissions.</div></div>;
  if (loading) return <div className="container mt-5 text-center"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;

  return (
    <div className="container mt-5" style={{maxWidth: 900}}>
      <h3 className="mb-4">My Publication Submissions</h3>
      {submissions.length === 0 ? (
        <div className="alert alert-info">No publication submissions yet.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Title</th>
                <th>Status</th>
                <th>Journal</th>
                <th>Submitted At</th>
                <th>PDF</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map(sub => (
                <tr key={sub.id}>
                  <td>{sub.title}</td>
                  <td>{sub.status}</td>
                  <td>{sub.journal}</td>
                  <td>{sub.submitted_at ? new Date(sub.submitted_at).toLocaleString() : '-'}</td>
                  <td>{sub.pdf_url ? <a href={sub.pdf_url} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger btn-sm">PDF</a> : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
} 